import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useNetSalesReport = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.netSalesReport, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getNetSalesReport(), {
        params,
      });

      const composeResponse = {
        providerNetSales: res.data.data.provider_net_sales_report,
        clinicNetSales: res.data.data.clinic_net_sales_report,
      };
      return composeResponse;
    },
    options,
  );
};
